import BaseEvent from "./BaseEvent";
export default class SVEvent extends BaseEvent {
    constructor(index) {
        super();
        this.PRIORITY = 1;
        this.INDEX = index;
    }
}
